import axios from '../../../http';
import router from '../../../routes';

const state = {
  isEconomy7: false,
  tariffDetails: [],
  supplierTosUrl: '',
  supplierId: 0,
  tariffName: null,
  supplierName: null,
  payMethod: 'MonthlyDirectDebit'
};

const getters = {
  notDirectDebit: (state) => {
    const directDebits = ['MonthlyDirectDebit', 'QuaterlyDirectDebit'];

    return directDebits.indexOf(state.payMethod) < 0;
  }
};

const actions = {
  async get({ rootState, commit, dispatch }) {
    const { switchKey } = rootState.storage;
    const { switchType } = rootState.storage.quote;
    const fuelTypes = {
      gasToGas: 'Gas',
      electricityToElectricity: 'Electricity',
      dualDistinctToDualConsolidated: 'Gas & Electricity',
      dualConsolidatedToDualConsolidated: 'Gas & Electricity'
    };

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/info/switch-plan',
        data: { switchKey }
      });

      if (status == 200) {
        const switchPlanInfoDto = data.geniusSwitchPlanInfoDto.geniusSwitchPlanInfo.switchPlanInfoDto;

        if (switchType == 'gasToGas') {
          switchPlanInfoDto.gas.fuelTitle = fuelTypes[switchType];
          commit('updateState', switchPlanInfoDto.gas);
        } else if (switchType == 'electricityToElectricity') {
          switchPlanInfoDto.electricity.fuelTitle = fuelTypes[switchType];
          commit('updateState', switchPlanInfoDto.electricity);
        } else {
          switchPlanInfoDto.electricity.fuelTitle = fuelTypes[switchType];
          switchPlanInfoDto.electricity.gasCost = switchPlanInfoDto.gas.cost;
          switchPlanInfoDto.electricity.gasSavings = switchPlanInfoDto.gas.savings;
          commit('updateState', switchPlanInfoDto.electricity);
        }
      }
    } catch (error) {
      router.push({ name: 'currentTariff' });
    }
  },
  async holdSwitch({ dispatch, rootState }) {
    const { switchKey, quote } = rootState.storage;
    const { tariffId, payMethod } = rootState.personal_details_switch_plan;

    const customerId = quote.switchId;
    const { completionDate } = rootState.session.quoteParams;

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/hold/switch',
        data: {
          switchKey,
          isTou: false,
          tariffId,
          payMethod,
          customerId,
          completionDate
        }
      });

      if (status == 200) {
        await dispatch('storage/save', {
          prop: 'isHoldSwitch',
          value: true
        }, { root: true });

        // Reset Query Params Journey
        await dispatch('session/setItem', { key: 'quoteParams', value: { isQuoteParamsJourney: false } });

        router.push({ name: 'switchHold' });
      } else {
        throw 'switch';
      }
    } catch (error) {
      throw 'switch';
    }
  },
  async holdSwitched({ dispatch, rootState }) {
    const { isHoldSwitch } = rootState.storage;

    if (isHoldSwitch) {
      router.push({ name: 'switchHold' });
    }

    return isHoldSwitch;
  },
  async completeSwitch({ dispatch, rootState }) {
    const { switchKey } = rootState.storage;
    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/complete',
        data: { switchKey, switchCompleteOption: 'None' }
      });

      if (status == 200) {
        await dispatch('storage/save', {
          prop: 'switched',
          value: {
            referenceNumber: data.geniusSwitchedDto.referenceNumbers.g || data.geniusSwitchedDto.referenceNumbers.e,
            name: `${data.geniusSwitchedDto.title} ${data.geniusSwitchedDto.firstName} ${data.geniusSwitchedDto.lastName}`,
            supplierName: data.geniusSwitchedDto.supplier
          }
        }, { root: true });
        await dispatch('storage/save', {
          prop: 'uuid',
          value: data.geniusSwitchedDto.uuid
        }, { root: true });

        router.push({ name: 'switchComplete' });
      } else {
        throw 'switch';
      }
    } catch (error) {
      throw 'switch';
    }
  },
  async notifyCompleteSwitch({ state, rootState }) {
    const { switchOwnerReference } = rootState.session.reference;
    const { switchId, switchType } = rootState.storage.quote;
    const annualTariffCost = state.gasCost ? state.gasCost + state.cost : state.cost;
    const eMap = {
      gasToGas: 1105,
      electricityToElectricity: 1105,
      dualDistinctToDualConsolidated: 1106,
      dualConsolidatedToDualConsolidated: 1106
    };

    if (switchOwnerReference) {
      try {
        await axios({
          method: 'GET',
          url: 'https://mywebconect.com/p.ashx',
          params: {
            o: 1895,
            e: eMap[switchType],
            f: 'pb',
            r: switchOwnerReference,
            t: switchId,
            p: 'PRICE',
            ect: annualTariffCost || 0
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  },
  async switched({ dispatch, rootState }) {
    const { quote } = rootState.storage;

    try {
      const { data } = await axios({
        method: 'POST',
        url: '/request/customer/whitelabel/switch/complete',
        data: { switchId: quote.switchId }
      });

      if (data) {
        await dispatch('storage/save', {
          prop: 'alreadySwitched',
          value: true
        }, { root: true });

        router.push({ name: 'switchComplete' });
      }

      return data;
    } catch (error) {
      return false;
    }
  }
};

const mutations = {
  updateState(state, value) {
    state = Object.assign(state, value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
